var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('vue-topprogress',{ref:"topProgress",attrs:{"color":_vm.loader.color}}),(_vm.alert.message)?_c('v-alert',{attrs:{"colored-border":"","border":"bottom","elevation":"2","dismissible":"","type":`${_vm.alert.type}`}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e(),_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }